var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'has-fixed-nav':_vm.isShowBtmTab},attrs:{"id":"app"}},[_c('router-view',{key:_vm.key}),_c('Btmbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowBtmTab),expression:"isShowBtmTab"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }